module.exports = __webpack_public_path__ + "static/img/HeNan_fengchaoPic.1a238ff0.png";